import Location from "./Location";
import Logo from "../assets/logos/rgb.png"
import Logo2 from "../assets/logos/RowCrop.png";

const locationsArray = [
    { title: "AgriNorthwest",city: "Kennewick, Washington", utcOffset: -7, countryCode: "us", lat: 46.2082, lon: -119.1002 },
    { title: "Canyon Falls Farms", city: "Burley, Idaho", utcOffset: -6, countryCode: "us", lat: 42.5294, lon: -113.7867 },
    { title: "Headquarters", city: "Salt Lake City, Utah", utcOffset: -6, countryCode: "us", lat: 40.7608, lon: -111.8910 },
    { title: "AgReserves Mexico", city: "Los Mochis,  Mexico", utcOffset: -6, countryCode: "mx", lat: 25.7794, lon: -109.0662 },
    { title: "AgReserves UK", city: "Huntingdon, United Kingdom", utcOffset: +1, countryCode: "gb", lat: 52.3205, lon: -0.1835 },
    { title: "AgReserves Brazil", city: "Formosa, Brazil", utcOffset: -2, countryCode: "br", lat: -28.2014, lon: -58.4023 },
    { title: "AgReserves Argentina", city: "Venado Tuerto, Argentina", utcOffset: -2, countryCode: "ar", lat: -33.2850, lon: -60.8594 },
    { title: "Australia Contract Direct", city: "Mungindi, Australia", utcOffset: +12, countryCode: "au", lat: -28.9692779, lon: 148.9888237 },
];

const containerStyle = {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
};

const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "20px",
};

const Locations = () => {
    return (
        <div style={containerStyle}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                <img src={Logo2} alt="Logo" style={{ height: "80px", marginRight: "14px" }} />
            </div>
            <div style={gridStyle}>
                {locationsArray.map((loc, idx) => (
                    <Location
                        key={idx}
                        title={loc.title}
                        city={loc.city}
                        utcOffset={loc.utcOffset}
                        countryCode={loc.countryCode}
                        lat={loc.lat}
                        lon={loc.lon}
                    />
                ))}
            </div>
        </div>
    );
};

export default Locations;